import { IntlShape } from 'react-intl';

export const currenciesArray = (intl: IntlShape) => {
  return [
    {
      currency: 'AUD',
      translatedName: intl.formatMessage({
        defaultMessage: 'Australian Dollar',
        id: 'b79q5t',
      }),
      name: '$AUD',
    },
    {
      currency: 'CAD',
      translatedName: intl.formatMessage({
        defaultMessage: 'Canadian Dollar',
        id: 'eLHmbF',
      }),
      name: '$CAD',
    },
    {
      currency: 'EUR',
      translatedName: intl.formatMessage({
        defaultMessage: 'Euro',
        id: 'Zz6d8X',
      }),
      name: '€EUR',
    },
    {
      currency: 'GBP',
      translatedName: intl.formatMessage({
        defaultMessage: 'British Pound',
        id: 'uM7wM0',
      }),
      name: '£GBP',
    },
    {
      currency: 'NZD',
      translatedName: intl.formatMessage({
        defaultMessage: 'New Zealand Dollar',
        id: 'lRYcoa',
      }),
      name: '$NZD',
    },
    {
      currency: 'USD',
      translatedName: intl.formatMessage({
        defaultMessage: 'United States Dollar',
        id: 'MPs9Su',
      }),
      name: '$USD',
    },
  ];
};
